import { Component, OnInit, OnDestroy } from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material';

import { AdminService, AlertService, CommonService } from '../../../_services/';

import { AddNewWebsiteDialogComponent } from '../add-new-website-dialog/add-new-website-dialog.component';
import { EditWebsiteDialogComponent } from '../edit-website-dialog/edit-website-dialog.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-website-list',
  templateUrl: './website-list.component.html',
  styleUrls: ['./website-list.component.scss']
})
export class WebsiteListComponent implements OnInit {
  websites:any[]=[];
  private subscription: Subscription;
  constructor(
    public dialog: MatDialog,
    private _common : CommonService,
    private _admin : AdminService,
    private _alert : AlertService

  ) { }

  ngOnInit() {
    this.getWebsiteList();
  }

  getWebsiteList(){
    // this._admin.create_marketing_list_entry({"key":"n66TqzHYw9Dg8hYyfxcbJJAFrifBr","marketing_list_id":"422616291"}).subscribe(res => {
    //   console.log(res,'response!!!');
    //   this._common.showLoader(false);
    // },err=>{
    //   console.log(JSON.stringify(err),'error!!!!');
    // }) 
    // return;


    this._common.showLoader(true);
    this.subscription = this._admin.getWebsiteList().subscribe(result=>{
      this._common.showLoader(false);
      this.websites = result;
    },err=>{
      this._common.showLoader(false);
      this._alert.error(err.error && err.error.message?err.error.message:'Something went wrong!');
    })
  }


  openAddNewWebsiteDialog(){
    let dialogRef = this.dialog.open(AddNewWebsiteDialogComponent, {
      width: 'auto',
    });

    dialogRef.afterClosed().subscribe(response => {
      
    })

  }

  // edit website dialog
  openEditWebsiteDialog(id){
    let dialogRef = this.dialog.open(EditWebsiteDialogComponent, {
      width: 'auto',
      data:{
        id:id
      }
    });

    dialogRef.afterClosed().subscribe(response => {
      // this.getUserList(localStorage.getItem('uid'))
    })

  }

  // delete website..
  deleteWebsite(id){
    this._common.showLoader(true);
    this._admin.deleteWebsite(id).then((res)=>{
      this._common.showLoader(false);
      this._alert.success('Website deleted successfully!');
    }).catch(err=>{
      this._common.showLoader(false);
      this._alert.error(err.error.message?err.error.message:'Something went wrong!');
    })
  }

  ngOnDestroy(){
    if(this.subscription) this.subscription.unsubscribe();
  }


}
